import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link, useParams} from "react-router-dom";
import {baseUrl} from "../Univ";
function OpDoc() {
    const {dept_id} = useParams();
    const [consData, setConsData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        axios.get(baseUrl + "cons-search/")
            .then((response) => {
                const filtered = response.data.filter(
                    doc => String(doc.department) === String(dept_id)
                );
                setConsData(filtered);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [dept_id]);
    return (
        <section className="container mt-4">

            <div className="text-center mb-5">

                <h2 className="op-title">

                    <i className="fa-solid fa-user-doctor me-2"></i>

                    Select Doctor

                </h2>

            </div>

            {loading && (
                <div className="text-center mt-5">

                    <div className="spinner-border text-primary"></div>

                </div>
            )}

            {!loading && consData.length === 0 && (
                <div className="text-center mt-5">

                    <div className="card p-5">

                        <i
                            className="fa-solid fa-user-doctor"
                            style={{
                                fontSize: "70px",
                                color: "#CBD5E1"
                            }}
                        ></i>

                        <h4 className="mt-4">

                            No Doctors Available

                        </h4>

                        <p className="text-muted">

                            No consultants found in this department.

                        </p>

                    </div>

                </div>
            )}

            <div className="row g-4">

                {consData.map((doctor) => (
                    <div
                        className="col-xl-3 col-lg-4 col-md-6"
                        key={doctor.id}
                    >

                        <Link
                            to={`/fix-appointment/${doctor.id}`}
                            className="text-decoration-none"
                        >

                            <div className="menu-card doctor-card">

                                <div className="doctor-avatar">

                                    <i
                                        className="fa-solid fa-user-doctor"
                                        style={{
                                            color: "#2563EB",
                                            fontSize: "50px"
                                        }}
                                    ></i>

                                </div>

                                <h5 className="doctor-name">

                                    Dr. {doctor.consultant}

                                </h5>

                                <div className="doctor-dept">

                                    {doctor.department}

                                </div>

                            </div>

                        </Link>

                    </div>
                ))}

            </div>

        </section>
    );
}
export default OpDoc;